var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6146 18.8611L14.8651 13.1093C15.8957 11.7037 16.4478 10.0043 16.4401 8.26133C16.4205 3.71162 12.7406 0.0263617 8.19089 8.35767e-05C6.01361 -0.00976736 3.92282 0.851568 2.3843 2.39221C0.845768 3.93285 -0.0126974 6.02482 0.000141975 8.20208C0.0198065 12.7522 3.70004 16.4378 8.25014 16.4641C10.0002 16.4717 11.7058 15.9131 13.1124 14.8718L13.1184 14.8673L18.8626 20.6146C19.1732 20.9404 19.636 21.0723 20.0717 20.9591C20.5073 20.846 20.8475 20.5056 20.9602 20.0698C21.073 19.634 20.9407 19.1714 20.6146 18.8611ZM8.24414 14.817C4.60426 14.7961 1.66012 11.8479 1.64414 8.20803C1.63432 6.46644 2.32115 4.79321 3.55174 3.56078C4.78233 2.32836 6.45454 1.63905 8.19614 1.64628C11.836 1.66722 14.7802 4.61538 14.7961 8.25528C14.806 9.99687 14.1191 11.6701 12.8885 12.9025C11.658 14.1349 9.98574 14.8243 8.24414 14.817Z",
    fill: "#A1A0A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.8a44f77100fb31f6f74f22aced8fd236.svg";
export { ForwardRef as ReactComponent };